<template>
  <div class="right-three-box">
    <div class="pallet-title"><span>托盘增长趋势</span><span>平台客户</span></div><!--<span>{{months}}月分地区统计使用比例</span>-->
    <div class="clear">
      <div style="width: 260px; height: 215px; float: left; position: relative">
        <div id="charts" class="echars-box"></div>
        <em style="position: absolute; right: -8px; bottom: 12px; font-size: 12px; color: #3494CF;font-style: normal">{{ unit }}</em>
      </div>
      <vue-seamless-scroll :data="clientlist" :class-option="classOption" class="seamless-warp">
        <ul class="client-group">
          <li v-for="(item,index) in clientlist" :key="index">{{item.memberName}}</li>
        </ul>
<!--        <div id="chartst" class="echars-box"></div>-->
<!--          <router-link to="/pallet" target="_blank" title="点击查看详情" class="btn btn13">-->
<!--            <span class="btn-inner">托盘总览》</span>-->
<!--            <div class="bgsqr1"></div>-->
<!--            <div class="bgsqr2"></div>-->
<!--          </router-link>-->
      </vue-seamless-scroll>
    </div>
  </div>
</template>

<script>
export default {
  name: 'right-module-pallet',
  props: {
    dataRefresh: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      months:'',
      unit:'',
      clientlist:[
        {
          "memberName": "杭****缆有限公司"
        },
        {
          "memberName": "苏****织有限公司"
        },
        {
          "memberName": "金****纱有限公司"
        },
        {
          "memberName": "长****技有限公司"
        },
        {
          "memberName": "晋****造有限公司"
        },
        {
          "memberName": "海****织有限公司"
        },
        {
          "memberName": "石****饰有限公司"
        },
        {
          "memberName": "嘉****料有限公司"
        },
        {
          "memberName": "海****百乐化纤厂"
        },
        {
          "memberName": "绍****织有限公司"
        },
        {
          "memberName": "广****织有限公司"
        },
        {
          "memberName": "杭****织有限公司"
        },
        {
          "memberName": "绍****料有限公司"
        },
        {
          "memberName": "桐****品有限公司"
        },
        {
          "memberName": "浙****料有限公司"
        },
        {
          "memberName": "诸****化纤经营部"
        },
        {
          "memberName": "杭****缆有限公司"
        },
        {
          "memberName": "长****织有限公司"
        },
        {
          "memberName": "宣****料有限公司"
        },
        {
          "memberName": "绍****品有限公司"
        },
        {
          "memberName": "江****料有限公司"
        },
        {
          "memberName": "安****技有限公司"
        },
        {
          "memberName": "绍****纺有限公司"
        },
        {
          "memberName": "江****纤有限公司"
        },
        {
          "memberName": "山****网有限公司"
        },
        {
          "memberName": "盐****易有限公司"
        },
        {
          "memberName": "海****其丙纺织厂"
        },
        {
          "memberName": "佛****技有限公司"
        },
        {
          "memberName": "安****技有限公司"
        },
        {
          "memberName": "杭****易有限公司"
        },
        {
          "memberName": "南****布有限公司"
        },
        {
          "memberName": "绍****织有限公司"
        },
        {
          "memberName": "江****纤有限公司"
        },
        {
          "memberName": "安****品有限公司"
        },
        {
          "memberName": "桐****业有限公司"
        },
        {
          "memberName": "厦****贸有限公司"
        },
        {
          "memberName": "杭****织有限公司"
        },
        {
          "memberName": "苏****织有限公司"
        },
        {
          "memberName": "安****品有限公司"
        },
        {
          "memberName": "安****业有限公司"
        },
        {
          "memberName": "厦****技有限公司"
        },
        {
          "memberName": "吴****织有限公司"
        },
        {
          "memberName": "桐****技有限公司"
        },
        {
          "memberName": "晋****织有限公司"
        },
        {
          "memberName": "吴****织有限公司"
        },
        {
          "memberName": "张****造有限公司"
        },
        {
          "memberName": "苏****纤有限公司"
        },
        {
          "memberName": "嘉****品有限公司"
        },
        {
          "memberName": "泉****限责任公司"
        },
        {
          "memberName": "绍****品有限公司"
        },
        {
          "memberName": "常****品有限公司"
        },
        {
          "memberName": "常****易有限公司"
        },
        {
          "memberName": "海****织有限公司"
        },
        {
          "memberName": "绍****纤有限公司"
        },
        {
          "memberName": "杭****有限公司 "
        },
        {
          "memberName": "湖****织有限公司"
        },
        {
          "memberName": "绍****织有限公司"
        },
        {
          "memberName": "吴****宁顺喷织厂"
        },
        {
          "memberName": "仪****纤有限公司"
        },
        {
          "memberName": "上****技有限公司"
        },
        {
          "memberName": "晋****造有限公司"
        },
        {
          "memberName": "滨****网有限公司"
        },
        {
          "memberName": "太****纤有限公司"
        },
        {
          "memberName": "浙****份有限公司"
        },
        {
          "memberName": "宁****织有限公司"
        },
        {
          "memberName": "浙****易有限公司"
        },
        {
          "memberName": "吴****造有限公司"
        },
        {
          "memberName": "嘉****份有限公司"
        },
        {
          "memberName": "海****编有限公司"
        },
        {
          "memberName": "福****技有限公司"
        },
        {
          "memberName": "苏****织有限公司"
        },
        {
          "memberName": "浙****料有限公司"
        },
        {
          "memberName": "浙****染有限公司"
        },
        {
          "memberName": "绍****技有限公司"
        },
        {
          "memberName": "江****维有限公司"
        },
        {
          "memberName": "杭****料有限公司"
        },
        {
          "memberName": "苏****织有限公司"
        },
        {
          "memberName": "吴****织有限公司"
        },
        {
          "memberName": "绍****纤有限公司"
        },
        {
          "memberName": "湖****织有限公司"
        },
        {
          "memberName": "苏****纤有限公司"
        },
        {
          "memberName": "杭****前交卫布厂"
        },
        {
          "memberName": "苏****限责任公司"
        },
        {
          "memberName": "绍****织有限公司"
        },
        {
          "memberName": "诸****织有限公司"
        },
        {
          "memberName": "四****品有限公司"
        },
        {
          "memberName": "吴****限责任公司"
        },
        {
          "memberName": "嘉****织有限公司"
        },
        {
          "memberName": "浙****技有限公司"
        },
        {
          "memberName": "海****弹有限公司"
        },
        {
          "memberName": "杭****织有限公司"
        },
        {
          "memberName": "宁****绒有限公司"
        },
        {
          "memberName": "江****织有限公司"
        },
        {
          "memberName": "海****万群加弹厂"
        },
        {
          "memberName": "诸****纤有限公司"
        },
        {
          "memberName": "诸****织有限公司"
        },
        {
          "memberName": "绍****织有限公司"
        },
        {
          "memberName": "浦****织有限公司"
        },
        {
          "memberName": "浙****份有限公司"
        },
        {
          "memberName": "苏****织有限公司"
        },
        {
          "memberName": "长****织有限公司"
        },
        {
          "memberName": "湖****织有限公司"
        },
        {
          "memberName": "绍****纤有限公司"
        },
        {
          "memberName": "绍****品有限公司"
        },
        {
          "memberName": "诸****纤有限公司"
        },
        {
          "memberName": "广****技有限公司"
        },
        {
          "memberName": "普****造有限公司"
        },
        {
          "memberName": "绍****料有限公司"
        },
        {
          "memberName": "诸****织有限公司"
        },
        {
          "memberName": "青****带有限公司"
        },
        {
          "memberName": "绍****纺有限公司"
        },
        {
          "memberName": "绍****品有限公司"
        },
        {
          "memberName": "绍****纤有限公司"
        },
        {
          "memberName": "杭****料有限公司"
        },
        {
          "memberName": "绍****纤有限公司"
        },
        {
          "memberName": "长****纤有限公司"
        },
        {
          "memberName": "太****纤有限公司"
        },
        {
          "memberName": "桐****份有限公司"
        },
        {
          "memberName": "海****技有限公司"
        },
        {
          "memberName": "晋****纤有限公司"
        },
        {
          "memberName": "绍****贸有限公司"
        },
        {
          "memberName": "惠****网有限公司"
        },
        {
          "memberName": "天****品有限公司"
        },
        {
          "memberName": "苏****技有限公司"
        },
        {
          "memberName": "石****易有限公司"
        },
        {
          "memberName": "夏****品有限公司"
        },
        {
          "memberName": "瑞****纤有限公司"
        },
        {
          "memberName": "嘉****料有限公司"
        },
        {
          "memberName": "绍****织有限公司"
        },
        {
          "memberName": "杭****料有限公司"
        },
        {
          "memberName": "长****技有限公司"
        },
        {
          "memberName": "海****技有限公司"
        },
        {
          "memberName": "绍****品有限公司"
        },
        {
          "memberName": "绍****纤有限公司"
        },
        {
          "memberName": "杭****织有限公司"
        },
        {
          "memberName": "杭****织有限公司"
        },
        {
          "memberName": "嘉****技有限公司"
        },
        {
          "memberName": "绍****品有限公司"
        },
        {
          "memberName": "绍****品有限公司"
        },
        {
          "memberName": "钦****装饰经营部"
        },
        {
          "memberName": "南****纤有限公司"
        },
        {
          "memberName": "绍****纤有限公司"
        },
        {
          "memberName": "吴****品有限公司"
        },
        {
          "memberName": "海****织有限公司"
        },
        {
          "memberName": "杭****技有限公司"
        },
        {
          "memberName": "苏****纤有限公司"
        },
        {
          "memberName": "苏****源有限公司"
        },
        {
          "memberName": "晋****易有限公司"
        },
        {
          "memberName": "诸****源祥化纤厂"
        },
        {
          "memberName": "杭****品有限公司"
        },
        {
          "memberName": "吴****织有限公司"
        },
        {
          "memberName": "滨****品有限公司"
        },
        {
          "memberName": "绍****纺有限公司"
        },
        {
          "memberName": "海****品有限公司"
        },
        {
          "memberName": "安****技有限公司"
        },
        {
          "memberName": "杭****纤有限公司"
        },
        {
          "memberName": "海****织有限公司"
        },
        {
          "memberName": "绍****装弹力丝厂"
        },
        {
          "memberName": "福****易有限公司"
        },
        {
          "memberName": "福****业有限公司"
        },
        {
          "memberName": "安****技有限公司"
        },
        {
          "memberName": "惠****网有限公司"
        },
        {
          "memberName": "湖****技有限公司"
        },
        {
          "memberName": "杭****织有限公司"
        },
        {
          "memberName": "长****纺有限公司"
        },
        {
          "memberName": "绍****织有限公司"
        },
        {
          "memberName": "浙****口有限公司"
        },
        {
          "memberName": "常****织有限公司"
        },
        {
          "memberName": "嵊****纤有限公司"
        },
        {
          "memberName": "苏****织有限公司"
        },
        {
          "memberName": "苏****饰有限公司"
        },
        {
          "memberName": "绍****品有限公司"
        },
        {
          "memberName": "蚌****织有限公司"
        },
        {
          "memberName": "盐****裕华加捻厂"
        },
        {
          "memberName": "太****纤有限公司"
        },
        {
          "memberName": "宿****织有限公司"
        },
        {
          "memberName": "普****造有限公司"
        },
        {
          "memberName": "安****技有限公司"
        },
        {
          "memberName": "浙****纤有限公司"
        },
        {
          "memberName": "海****利弹力丝厂"
        },
        {
          "memberName": "诸****事达化纤厂"
        },
        {
          "memberName": "绍****饰有限公司"
        },
        {
          "memberName": "诸****纤有限公司"
        },
        {
          "memberName": "吴****贸有限公司"
        },
        {
          "memberName": "诸****纤有限公司"
        },
        {
          "memberName": "宿****织有限公司"
        },
        {
          "memberName": "杭****织有限公司"
        },
        {
          "memberName": "杭****纤有限公司"
        },
        {
          "memberName": "诸****纤有限公司"
        },
        {
          "memberName": "福****易有限公司"
        },
        {
          "memberName": "绍****纤有限公司"
        },
        {
          "memberName": "诸****纤有限公司"
        },
        {
          "memberName": "杭****品有限公司"
        },
        {
          "memberName": "绍****织有限公司"
        },
        {
          "memberName": "诸****纤有限公司"
        },
        {
          "memberName": "苏****织有限公司"
        },
        {
          "memberName": "诸****纤有限公司"
        },
        {
          "memberName": "昌****织有限公司"
        },
        {
          "memberName": "海****织有限公司"
        },
        {
          "memberName": "绍****品有限公司"
        }
      ]
    }
  },
  mounted () {
    let $this=this
    $this.getpalletlist()
    // this.$api.post('/spis/member/name/getlist?pageNo=1&pageSize=200', {pageNo:1,pageSize:10}, (response) => {
    //   var datasl=response.data.records||[]
    //   var total=response.data.total||0
    //   $this.clientlist=datasl
    //   $this.$emit('clienttotal',total)
    // });
    $this.$emit('clienttotal',6626)
    $this.dataRefresh.$ons('Refresh',()=>{
      $this.getpalletlist()
    })

  },
  computed:{
    classOption(){
      return{
        step:0.2,// 数值越大速度滚动越快
        limitMoveNum:2,// 开始无缝滚动的数据量 this.dataList.length
        hoverStop:true,// 是否开启鼠标悬停stop
        direction:1,// 0向下 1向上 2向左 3向右
        openWatch:true,// 开启数据实时监控刷新dom
        singleHeight:0,// 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth:0,// 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime:1000,// 单步运动停止的时间(默认值1000ms)
      }
    }
  },
  methods: {
    initEchars (mot,tp) {
      const myEcharts = this.$echarts.init(document.getElementById('charts'))
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          show: false
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '0',
          top: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'value',
          scale:true,
          min:val=>{
            return Math.ceil(val.min-50000)>0? Math.ceil(val.min-50000):val.min
          },
          nameTextStyle:{
            color: '#C1D3F4'
          },
          splitLine: {
            lineStyle: {
              color: '#4C4D52'
            }
          },
          axisLabel:{
            interval: 2,
            rotate: '45',
            color:'#3494CF',
            formatter: function (params) {
              if(params>100000){
                params=Math.ceil(params/10000)
              }
              return params
            }
          }
        },
        yAxis: {
          type: 'category',
          name:'月',
          data: mot,
          axisLabel:{
            color:'#fff'
          }
        },
        series: [
          {
            name: '托盘总量',
            type: 'bar',
            data: tp,
            itemStyle:{
              color:{
                type:'linear',
                x:1,
                y:0,
                x2:0,
                y2:0,
                colorStops:[
                  {
                    offset:0,
                    color:'#0248F5'
                  },{
                    offset:0.5,
                    color:'#02D2EC'
                  },{
                    offset:1,
                    color:'#37FFA6'
                  }
                ]
              }
            }
          },
          // {
          //   name: 'FDY',
          //   type: 'bar',
          //   data: fdy,
          //   itemStyle:{
          //     color:{
          //       type:'linear',
          //       x:1,
          //       y:0,
          //       x2:0,
          //       y2:0,
          //       colorStops:[
          //         {
          //           offset:0,
          //           color:'#AE2CFE'
          //         },{
          //           offset:0.5,
          //           color:'#CFA7FF'
          //         },{
          //           offset:1,
          //           color:'#FA8B46'
          //         }
          //       ]
          //     }
          //   }
          // }
        ]
      }
      myEcharts.setOption(option)
      // myEcharts.on('click',params=>{
      //   let name=params.name||''
      //   this.updatePieEchars(name)
      // })
      // this.updatePieEchars(mot[5])
    },
    updatePieEchars (val){//获取月地区统计数据
      this.months=val*1
      const url = '/api-portal/branch/jzRecycleCount?monthStart=2022-'+val+'&monthEnd=2022-'+val;
      this.$api.post(url, {}, (response) => {
        let datas=response.data||''
        if(datas){
          let echartdata= [];
          for(var i=0;i<datas.length;i++){
            var cityName=datas[i].cityName||''
            var cout=datas[i].recycleCountTotal||0
            var istrue=0
            var nums=echartdata.length
            if(nums>0){
              for(var j=0;j<nums;j++){
                if(echartdata[j].name==cityName){
                  echartdata[j].value+=cout
                  istrue=1
                }
                if(j==nums-1&&istrue==0){
                  let dar={}
                  dar['name']=cityName
                  dar['value']=cout
                  echartdata.push(dar)
                }
              }
            }else {
              let dar={}
              dar['name']=cityName
              dar['value']=cout
              echartdata.push(dar)
            }
          }
          this.initbingtu(echartdata,val)
        }
      })
    },
    initbingtu(datas,val){
      const myEchartst = this.$echarts.init(document.getElementById('chartst'))

      let options = {
        // color: ['#FF4948','#FA9020','#8365E2','#E5EA04','#35A8FA','#20D479'],
        color: ['#993AF5','#BF3C99','#7EFBFD','#4676F5','#3241F4','#5733F4'],
        tooltip: {
          formatter:val+"月<br/>{b}:{d}%"
        },
        legend: {
          top: '15%',
          right: '1%',
          icon:'circle',
          width:18,
          itemWidth:9,
          itemHeight:9,
          textStyle:{
            fontSize: 10,
            color:'#fff'
          }
        },
        series: [
          {
            name: val+'月地区统计',
            type: 'pie',
            radius: [30, 56],
            center: ['30%', '48%'],
            roseType: 'area',
            itemStyle: {
              borderRadius: 2,
              // normal: {
              //   // 设置扇形的阴影
              //   shadowBlur: 30,
              //   shadowColor: 'rgba(255,227,42,0.3)',
              //   shadowOffsetX: -3,
              //   shadowOffsetY: 3
              //
              // }
            },
            label: {
              show: true,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '18',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: datas
          }
        ]
      }
      myEchartst.setOption(options)
    },
    getpalletlist(){
      let $this=this
      let year= new Date().getFullYear()
      let month= new Date().getMonth()+1
      let month2= new Date().getMonth()-5
      let year2=year
      month=month<10?'0'+month:month
      month2=month2<10?'0'+month2:month2
      let times=year+'-'+month
      let times2=year+'-'+month2
      if(month*1<=5){
        let m3=month*1+7
        times2=year-1+'-'+(m3<10?'0'+m3:m3)
      }
      const url = '/api-portal/pallet/list?monthStart='+times2+'&monthEnd='+times;
      $this.unit=''
      $this.$api.post(url, {}, (response) => {
        let datas=response.data||''
        if(datas){
          let records=datas.origPage.records
          let mot=[]
          let tp=[]
          let fdy=datas.baseCount[0]?datas.baseCount[0].total:0
          let poy=datas.baseCount[1]?datas.baseCount[1].total:0
          for(var i=0;i<records.length;i++){
            const datad=records[i]
            const reportMonths=datad.reportMonth||''
            const mon=reportMonths.substring(5)
            const count=datad.palletCount||0
            const indexnum=mot.indexOf(mon)
            if(indexnum<0){
              mot.push(mon);
              if(i==0){
                tp.push(count*1+fdy*1+poy*1)
              }else {
                // tp.push(count*1+tp.at(-1))
                tp.push(count*1+tp[tp.length-1])
              }
            }else {
              const nn=tp[indexnum]
              tp[indexnum]=nn*1+count*1
            }
          }
          // let nums=mot.length;
          // let poy=new Array(nums).fill(0)
          // let fdy=new Array(nums).fill(0)
          // for (var j=0;j<records.length;j++){
          //   const reportMonths=records[j].reportMonth||''
          //   const mon=reportMonths.substring(5)
          //   const name=records[j].productName||''
          //   const count=records[j].palletCount||0
          //   const indexs=mot.indexOf(mon)
          //   if(name=="POY"){
          //     poy[indexs]=count
          //   }else {
          //     fdy[indexs]=count
          //   }
          // }
          this.initEchars(mot,tp)
          $this.unit='万'
        }
      });
    }
  }
}
</script>

<style scoped>
.right-three-box {
  padding: 20px;
  display: block;
  width: calc(100% - 40px);
  height: calc(100% - 40px);
}
.echars-box {
  width: 100%;
  height: 100%;
  display: block;
}
.pallet-title{
  display: flex;
  justify-content:space-around;
  color: #00D2E9;
  font-size: 14px;
  margin: 17px 0 8px;
}

.seamless-warp{
  width:200px;
  height:210px;
  overflow: hidden;
  float: left;
  margin-left: 12px;
  background: rgba(0,0,0,.4)
}

.client-group{
  padding: 5px 10px;
}

.client-group li{
  background: rgba(9,42,92,.65);
  color: #D2FBFF;
  font-size: 14px;
  height: 24px;
  width: 100%;
  box-sizing: border-box;
  padding: 0 16px;
  border-left: 1px solid #35FEA9;
  line-height: 24px;
  margin: 5px 0;
}

/*.btn{ display: inline-block; *display:inline; *zoom:1; padding: 8px 20px; margin-top: 6px; text-decoration: none; position: relative; color:#333; cursor: pointer}*/
/*.btn13{ border:1px solid #012979; background: #012979; position:relative; color: #BEE5FB; overflow: hidden; -webkit-transition: all .6s;transition: all .6s; width: 80px; border-radius: 5px; margin-left: 29px;margin-top: 6px}*/
/*.btn13:hover{ color:#fff; border-color:#3254DD;}*/
/*.btn13 .bgsqr1{content: '';width: 0;height: 0;-webkit-transform: rotate(360deg); transform: rotate(360deg);border-style: solid;border-width: 0; border-top-color:transparent;border-right-color:transparent;border-bottom-color:transparent; border-left-color:#3254DD;position: absolute;bottom: 0;left: 0; -webkit-transition: all 0.6s; transition: all 0.6s;}*/
/*.btn13 .bgsqr2{content: '';width: 0;height: 0;-webkit-transform: rotate(360deg);transform: rotate(360deg);border-style: solid;border-width: 0; border-top-color:transparent;border-left-color:transparent;border-bottom-color:transparent; border-right-color:#3254DD;position: absolute;top: 0; right: 0;-webkit-transition: all 0.6s; transition: all 0.6s;}*/
/*.btn13:hover .bgsqr1{ border-width:50px 260px;}*/
/*.btn13:hover .bgsqr2{ border-width:50px 260px;}*/
/*.btn13 span{ position:relative; z-index:1;}*/
</style>



// WEBPACK FOOTER //
// src/views/HomeManage/module/right-module-pallet.vue